import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-screen grid place-items-center bg-cream px-5 pt-24">
      <div className="text-center">
        <p className="font-display text-[8rem] leading-none text-forest">404</p>
        <p className="text-forest/70 mt-2 mb-8">This page has been shipped elsewhere.</p>
        <Link to="/" data-testid="notfound-home-link" className="inline-flex items-center gap-2 rounded-full bg-forest text-butter px-6 py-3 text-sm font-semibold hover:bg-forest-deep transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </Link>
      </div>
    </section>
  );
}
